// extracted by mini-css-extract-plugin
module.exports = {"sierraChatContainer":"sierra-agent_sierraChatContainer__UzTVR","hidden":"sierra-agent_hidden__vcNMv","actionButton":"sierra-agent_actionButton__O3pdu"};